import { getAccessTokenFromCookie } from "../util/authentication";
import {
  TRADE_SERVICE_API_ADD_TRADE_FORM_EVENT,
  TRADE_SERVICE_API_ELIGIBILITY,
  TRADE_SERVICE_API_GET_LATEST_TRADE_EVENTS_BY_EMPLOYEE_AND_DATE,
  TRADE_SERVICE_API_GET_LATEST_TRADE_EVENTS_BY_STATION_AND_DATE,
  TRADE_SERVICE_API_GET_LATEST_TRADE_EVENT_BY_REFERENCE_NUMBER,
  TRADE_SERVICE_API_GET_LATEST_TRADE_EVENT_BY_TRADE_FORM_ID,
  TRADE_SERVICE_API_GET_TRADE_EVENTS_BY_TRADE_FORM_ID,
  TRADE_SERVICE_API_TRADE_EVENT_ELIGIBILITY,
} from "../util/constants";

export const fetchTradeDataByTradeFormId = async (tradeFormId) => {
  const apiEndpoint =
    process.env.REACT_APP_TRADE_SERVICE_API +
    TRADE_SERVICE_API_GET_LATEST_TRADE_EVENT_BY_TRADE_FORM_ID +
    "/" +
    tradeFormId;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchTradeDataByReferenceNumber = async (referenceNumber, eid, station, isAdminPage) => {
  const apiEndpoint =
    process.env.REACT_APP_TRADE_SERVICE_API +
    TRADE_SERVICE_API_GET_LATEST_TRADE_EVENT_BY_REFERENCE_NUMBER +
    "/" +
    referenceNumber +
    "/" +
    eid +
    "/" +
    station +
    "/" +
    isAdminPage;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchLatestEmployeeTradeEvents = async (eid, dateType, startDate, endDate) => {
  const apiEndpoint =
    process.env.REACT_APP_TRADE_SERVICE_API +
    TRADE_SERVICE_API_GET_LATEST_TRADE_EVENTS_BY_EMPLOYEE_AND_DATE +
    "/" +
    eid +
    "/" +
    dateType +
    "/" +
    startDate +
    "/" +
    endDate;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Calling-User-EID": eid,
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    console.error(response);
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchLatestStationTradeEvents = async (eid, station, dateType, startDate, endDate) => {
  const apiEndpoint =
    process.env.REACT_APP_TRADE_SERVICE_API +
    TRADE_SERVICE_API_GET_LATEST_TRADE_EVENTS_BY_STATION_AND_DATE +
    "/" +
    station +
    "/" +
    dateType +
    "/" +
    startDate +
    "/" +
    endDate;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Calling-User-EID": eid,
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    if (response.status === 400) {
      return response;
    }
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const fetchTradeFormEventsByTradeFormId = async (tradeFormId, eid, isAdminPage) => {
  const apiEndpoint =
    process.env.REACT_APP_TRADE_SERVICE_API +
    TRADE_SERVICE_API_GET_TRADE_EVENTS_BY_TRADE_FORM_ID +
    "/" +
    tradeFormId +
    "/" +
    eid +
    "/" +
    isAdminPage;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  if (!response.ok) {
    throw Error(`GET ${apiEndpoint} API Call failed.`);
  }
  return response;
};

export const addTradeFormEvent = async (tradeFormEventPayload) => {
  const apiEndpoint = process.env.REACT_APP_TRADE_SERVICE_API + TRADE_SERVICE_API_ADD_TRADE_FORM_EVENT;
  try {
    const response = await fetch(apiEndpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
      body: tradeFormEventPayload,
    });
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const fetchEmployeesEligibleToTrade = async (station, jobCode, tradeFormType) => {
  const apiEndpoint =
    process.env.REACT_APP_TRADE_SERVICE_API +
    TRADE_SERVICE_API_ELIGIBILITY +
    "/" +
    station +
    "/" +
    jobCode +
    "/" +
    tradeFormType;
  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });
  return response;
};

export const isTradeEventEligible = async (tradeEvent) => {
  let apiEndpoint =
    process.env.REACT_APP_TRADE_SERVICE_API +
    TRADE_SERVICE_API_TRADE_EVENT_ELIGIBILITY +
    "/" +
    tradeEvent.station +
    "/" +
    tradeEvent.offeredEmployeeId +
    "/" +
    tradeEvent.requestedEmployeeId +
    "/" +
    tradeEvent.offeredShiftStart;

  if (tradeEvent.requestedShiftStart) {
    apiEndpoint = apiEndpoint + "/" + tradeEvent.requestedShiftStart;
  }

  const response = await fetch(apiEndpoint, {
    headers: {
      "Content-Type": "application/json",
      authorization: "Bearer " + getAccessTokenFromCookie(),
    },
  });

  return response.status === 200;
};
